<template>
    <div class="body">

        <v-snackbar
                v-model="snackbar"
                bottom
                color="success"
                style="direction: rtl; text-align: center"
                :timeout="1500"
        >
            {{ message }}
        </v-snackbar>
        <DataTable
                :url="url"
                :title="$t('drivers.changeCaptainReasons.title')"
                :titles="titles"
                :fields-hidden-add="['id' , 'created_at', 'updated_at','deleted_at']"
                :fields-hidden-edit="['id' , 'created_at', 'updated_at','deleted_at']"
                :fields-hidden-main="['updated_at','created_at','deleted_at']"
                :fields-extra-add="fieldsExtraAdd"
                :disableSearch="true"
        />
    </div>

</template>

<script>
    import DataTable from "@/components/monaco/DataTable";
    export default {
        name: "ChangeCaptainReasons",
        title() { return this.$t("drivers.changeCaptainReasons.title"); },
        components: {DataTable},
        data() {
            return {
                snackbar: false,
                message: "",
                valid: true,
                lazy: false,
                loading: false,
                url: "captain/change_captain_reason",
            }
        },
        computed: {
            titles() {
                return {
                    id: '#',
                    reason: this.$t('drivers.changeCaptainReasons.reason'),

                }
            },
            fieldsExtraAdd() {
                return {
                    reason: 'v-text-field',
                }
            }
        },


    }
</script>

<style scoped>

</style>
